import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Button from 'react-bootstrap-button-loader';
import { Panel, Row, Col } from 'react-bootstrap';
import get from 'lodash/get';

import SearchForm from '../../jobs/SearchForm';
import AdvertiserApi from '../../../../api/AdvertiserApi';
import { humanize } from '../../../../utils/helpers/text_formatters'

class WizardFormStepTwo extends Component {
  state = {
    jobsRequiredError: false
  }

  getLocations(q, callback) {
    if (q.length) {
      if (!this.autocompleteService && window.google && window.google.maps) {
        this.autocompleteService = new window.google.maps.places
          .AutocompleteService();
      }
      if (this.autocompleteService) {
        this.autocompleteService.getPlacePredictions(
          {
            input: q,
            types: ['(regions)'],
            componentRestrictions: { country: 'us' }
          },
          predictions => {
            let options = [];
            if (predictions) {
              options = predictions.map(prediction => ({
                label: prediction.description,
                value: prediction.description
              }));
            }
            callback(null, { options });
          }
        );
      } else {
        callback(null, { options: [] });
      }
    } else {
      callback(null, { options: [] });
    }
  }

  fetchJobs(params = {}) {
    const { account, dispatch } = this.props;

    if (account.uuid) {
      const data = { ...params, account_id: account.uuid };
      dispatch(AdvertiserApi.actions.jobs.get(data));
    }
  }

  selectJob(row, isSelected) {
    const { onSelectJobs } = this.props;

    this.setState({ jobsRequiredError: false });
    onSelectJobs(row, isSelected);
  }
  
  selectAllJobs(isSelected) {
    const { onSelectAllJobs, jobs } = this.props;
    
    onSelectAllJobs(isSelected, jobs.data);
  }

  handleOnPageChange(page, per_page) {
    const { category, query, location } = this.props;
    this.fetchJobs({
      category,
      query,
      location,
      page,
      per_page
    });
  }
  
  handleSubmit() {
    const { onSubmit, selected } = this.props;
    if (selected.length > 0) {
      onSubmit();
    } else {
      this.setState({ jobsRequiredError: true });
    }
  }

  render() {
    const { handleSubmit, prev, account, jobs, selected } = this.props;
    const { jobsRequiredError } = this.state;
    const { data, meta } = jobs || {};
    const { pagination } = meta || {};
    const perPageList = [10, 20, 50, 100];
    const totalCount = get(pagination, 'total_count', null);
    const fetchInfo = {
      dataTotalSize: totalCount || 0
    };

    const selectRow = {
      mode: 'checkbox',
      clickToSelect: true,
      onSelect: this.selectJob.bind(this),
      onSelectAll: this.selectAllJobs.bind(this),
      selected
    };

    const options = {
      sizePerPage: get(pagination, 'per_page', 20),
      onPageChange: this.handleOnPageChange.bind(this),
      sizePerPageList: perPageList,
      pageStartIndex: 1,
      page: get(pagination, 'current_page', 1)
    };
    
    return (
      <Panel className="create-campaign">
        <Panel.Body>
          <form onSubmit={handleSubmit}>
            <div className='text-center'>
              <h3>Select the Jobs that will be in your Campaign</h3>
              <p className="wizard-instructions">
                From the list of jobs in your "Job Inventory," select the jobs you want to convert to ads.
                <br />
                The jobs selected will be converted into ads that will be served to our publishers when the campaign is created and approved.
              </p>
              <div style={{ textAlign: 'left' }}>
                <Row>
                  <Col md={12}>
                    <SearchForm account={account} getLocations={this.getLocations.bind(this)} />
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <BootstrapTable
                      striped
                      ref='campaignJobsTable'
                      data={data || []}
                      remote
                      pagination
                      selectRow={selectRow}
                      fetchInfo={fetchInfo}
                      options={options}
                      tableStyle={{
                        backgroundColor: 'white',
                      }}
                      bodyStyle={{
                        maxHeight: '500px',
                        overflow: 'auto'
                      }}
                      tableContainerClass={jobsRequiredError ? 'campaign-jobs-has-error' : ''}
                    >
                      <TableHeaderColumn
                        isKey
                        dataField='referencenumber'
                        hidden
                      >
                        ID
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField='title'
                        dataFormat={(c) => c}
                        width='200'
                      >
                        Title
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        width='200'
                        dataField='company'
                        dataFormat={(c) => c}
                      >
                        Company
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        width="200"
                        dataField='category'
                        dataFormat={(c) => c}
                      >
                        Category
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        width="300"
                        dataField='city'
                        dataFormat={(c, r) => {
                          return `${r.city} - ${humanize(r.state)}`;
                        }}
                      >
                        Location
                    </TableHeaderColumn>
                    </BootstrapTable>
                  </Col>
                </Row>
              </div>
              <div className="wizard-form-nav">
                <Button
                  onClick={prev}
                >
                  Back
                </Button>
                <Button
                  onClick={this.handleSubmit.bind(this)}
                >
                  Next
                </Button>
              </div>
            </div>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

const ResourceForm = reduxForm({
  form: 'campaignWizardForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
});

const mapStateToProps = (state) => {
  const {
    form,
    advertiser: { jobs: { data: jobs, loading: jobsLoading } }
  } = state;
  const searchParams = get(form, 'SearchForm.values', {});

  return {
    jobs,
    jobsLoading,
    searchParams,
    category: get(state, 'form.SearchForm.values.category', []),
    query: get(state, 'form.SearchForm.values.query', []),
    location: get(state, 'form.SearchForm.values.location', []),
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(ResourceForm(WizardFormStepTwo));
